import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a5c158b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Button__Label text" }

import { computed } from 'vue';
import type { PropType } from 'vue';
import AudioManager from '@/core/audio/AudioManager';


enum Variations {
  Primary = 'primary',
  Secondary = 'secondary'
}

const __default__ = {};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'UIBtn',
  props: {
  label: {
    type: String,
    required: true
  },
  isDisabled: {
    type: Boolean,
    default: false
  },
  variation: {
    type: String as PropType<Variations>,
    default: Variations.Primary
  },
  fileName: {
    type: String,
    default: ''
  },
  tag: {
    type: String as PropType<HTMLElementTagNameMap>,
    default: 'button'
  },
  downloadLink: {
    type: String,
    default: ''
  },
  thin: {
    type: Boolean,
    default: false
  }
},
  setup(__props) {

const props = __props;



const isPrimary = computed(() => props.variation === Variations.Primary);

const onClick = (e: any) => {
  //AudioManager.instance.playUI("6_UI_secondary-click", 0.4)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(__props.tag), {
    class: "Button__Wrapper",
    download: __props.downloadLink.length && __props.fileName,
    href: __props.downloadLink,
    onClick: onClick
  }, {
    default: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, _toDisplayString(__props.label), 1)
    ]),
    _: 1
  }, 8, ["download", "href"]))
}
}

})